import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { CREATE_SERVICE_WORTH, CREATE_SERVICE_WORTH_SUCCESS, CREATE_SERVICE_WORTH_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* createServiceWorth({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/assign-coins`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Service worth created successfully`);
      yield put({
        type: CREATE_SERVICE_WORTH_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_SERVICE_WORTH_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_SERVICE_WORTH_ERROR, payload: error });
  }
}

export function* watchCreateServiceWorth() {
  yield takeEvery(CREATE_SERVICE_WORTH, createServiceWorth);
}

function* createServiceWorthSaga() {
  yield all([fork(watchCreateServiceWorth)]);
}

export default createServiceWorthSaga;
